import { Swiper } from "swiper/bundle";
import { deviceWidth } from "./device";

export function recruitMemberSlider() {
  // console.log("test");
  const swiper = new Swiper(".member_list", {
    // Optional parameters
    //   direction: "vertical",
    loop: true,
    autoHeight: true,
    slidesPerView: 2.5,
    spaceBetween: 80,
    initialSlide: 0,
    centeredSlides: true,
    allowTouchMove: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    // clickable: true,
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    breakpoints: {
      992: {
        initialSlide: 0,
        centeredSlides: true,
        slidesPerView: 4.5,
      },
    },

    // If we need pagination
    //   pagination: {
    //     el: ".swiper-pagination",
    //   },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // And if we need scrollbar
    //   scrollbar: {
    //     el: ".swiper-scrollbar",
    //   },
  });

  swiper.on("slideChnage", function () {
    console.log(this);
  });




  let angle_image = $(".rm_schedule__photo img");



  $(window).on("scroll", function () {
    let scroll_position = $(window).scrollTop();
    let window_height = $(window).height();

    angle_image.each(function () {
      let elm_offset = $(this).offset().top;

      if (scroll_position > elm_offset - window_height + window_height / 3) {
        // console.log(scroll_position, elm_offset);

        $(this).addClass("roatete_img");
      }
    });
  });

  // isMobile

  let targetElms = $(".rec_top__interview__link");

  $(window).on("resize load", function () {
    targetElms.each(function () {
      if (deviceWidth().width < 768) {
        $(this).addClass("isMobile");
      } else {
        $(this).removeClass("isMobile");
      }
    });
  });
}
